import type React from 'react'

import { clsJoin } from '@/utils'
import css from './styles.module.css'

interface Props {
  link: string
  title: string
  description?: string
  imageUrl?: string
  classname?: 'twitter' | 'linkedin' | 'facebook'
}

export const Socials: React.FC<Props> = ({
  title,
  description,
  link,
  imageUrl,
  classname,
}) => {
  const classNames = clsJoin(
    css.socials_container,
    classname === 'twitter' && css.twitter,
    classname === 'linkedin' && css.linkedin,
    classname === 'facebook' && css.facebook
  )

  return (
    <div className={classNames}>
      {imageUrl && (
        <div className={css.imageWrap}>
          <img className={css.image} src={imageUrl} alt="" />
        </div>
      )}
      <div className={css.textWrap}>
        <div className={css.link}>{link}</div>
        <div className={css.title}>{title}</div>
        {description && <div className={css.description}>{description}</div>}
      </div>
    </div>
  )
}
